/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestConnectionResultDto } from '../../models/test-connection-result-dto';

export interface DatasourcesDataSourceIdTestPost$Json$Params {
  dataSourceId: string;
}

export function datasourcesDataSourceIdTestPost$Json(http: HttpClient, rootUrl: string, params: DatasourcesDataSourceIdTestPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TestConnectionResultDto>> {
  const rb = new RequestBuilder(rootUrl, datasourcesDataSourceIdTestPost$Json.PATH, 'post');
  if (params) {
    rb.path('dataSourceId', params.dataSourceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestConnectionResultDto>;
    })
  );
}

datasourcesDataSourceIdTestPost$Json.PATH = '/datasources/{dataSourceId}/test';
